module.exports = __webpack_public_path__ + "static/media/surfair_card_1.9d786de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/surfair_card_1.png
// module id = 518
// module chunks = 0